
import { Appointment } from '../types/appointmentTypes';

export const canRequestRefund = (appointment: Appointment) => {
  const now = new Date();
  const appointmentDate = new Date(appointment.start_time);
  const daysSinceAppointment = Math.floor((now.getTime() - appointmentDate.getTime()) / (1000 * 60 * 60 * 24));
  
  // Only allow refunds for completed appointments, not upcoming ones
  const validStatuses = ['Completed'];
  const invalidRefundStatuses = ['Requested', 'Approved', 'Processed', 'Failed'];

  return (
    validStatuses.includes(appointment.status) &&
    (!appointment.refund_status || !invalidRefundStatuses.includes(appointment.refund_status)) &&
    // Only show refund button if there's a stripe payment intent (i.e., not free booking)
    appointment.stripe_payment_intent_id !== null && 
    appointment.stripe_payment_intent_id !== '' &&
    // Only allow refunds within 7 days of the appointment date
    Math.abs(daysSinceAppointment) <= 7 &&
    // Ensure it's a paid booking (price > 0)
    appointment.price_at_booking > 0
  );
};
